import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { updateUserValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import usePermission from "../../customHooks/usePermission";
const UserLoginInfo = (props: any) => {
  const { user, profile, refetch } = props;
  const {
    register,
    setValue,
    getValues,
    clearErrors,
    setError,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(updateUserValidationForm),
    defaultValues: async () => {
      let data: any = await refetch();
      return {
        username: user.username,
        full_name: user.profile.full_name,
        email: user.email,
        branch: user?.default_branch,
        mobile_number: user?.mobile_number,
        alt_email: user?.profile.email,
        alt_mobile_number: user?.profile.contact_number,
        address_name: data?.data?.[0]?.address_name ?? null,
      };
    },
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.USER}${user?.id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
const canEditStaff = usePermission({
    allowedPermissions: ["can_update_staff"],
  });
  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) =>
          handleUpdateProfile(data, setError)
        )}
        autoComplete="off"
      >
        <div className={tw`grid  md:grid-cols-2 gap-x-4 mx-4`}>
          <TextField
            label={"Username"}
            register={register("username", {
              disabled: !canEditStaff,
            })}
            errors={errors?.username}
          />
          <TextField
            label={"Full Name"}
            register={register("full_name")}
            errors={errors?.full_name}
          />
          <TextField
            label={"Email"}
            register={register("email", { disabled: !canEditStaff })}
            errors={errors?.email}
          />
          <TextField
            label={"Alt Email"}
            register={register("alt_email")}
            errors={errors?.alt_email}
          />
          <PhoneNumberField
            control={control}
            label={"Mobile Number"}
            name={"mobile_number"}
            errors={errors?.mobile_number}
          />
          <PhoneNumberField
            control={control}
            label={"Alt Mobile Number"}
            name={"alt_mobile_number"}
            errors={errors?.alt_mobile_number}
          />
          <TextField
            label={"Address"}
            register={register("address_name")}
            errors={errors?.address_name}
          />
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("branch")}
            errors={errors?.branch}
            name={"branch"}
            label={"Branch"}
            props={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px] mr-4`}>
            <Button
              label={"Update"}
              disabled= {!canEditStaff}
              isLoading={isPatchLoading}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default UserLoginInfo;
